interface Props {
  width?: number;
  height?: number;
}

const HolaVidaLogo = ({ width = 140, height = 78 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Layer_1" clipPath="url(#clip0_1165_6487)">
        <path
          id="Vector"
          d="M12.588 56.6895V65.1348H4.30163V56.6895H0V77.63H4.30163V68.8435H12.588V77.63H16.8896V56.6895H12.588Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_2"
          d="M29.3533 61.5625C24.2978 61.5625 20.1523 65.2753 20.1523 69.7809C20.1523 74.2866 24.2978 77.9974 29.3827 77.9974C34.4677 77.9974 38.6448 74.3193 38.6448 69.8934C38.6448 65.2181 34.5945 61.5625 29.3533 61.5625ZM29.4145 74.54C26.589 74.54 24.3612 72.4149 24.3612 69.7238C24.3612 67.145 26.6523 65.024 29.3827 65.024C32.1788 65.024 34.4383 67.1777 34.4383 69.785C34.4383 72.3924 32.1788 74.54 29.4145 74.54Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_3"
          d="M40.9922 56.6895V77.63H45.1693V56.6895H40.9922Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_4"
          d="M62.3201 61.9324V64.0288C60.8757 62.3001 59.1505 61.5625 56.6375 61.5625C51.4891 61.5625 47.7852 65.0485 47.7852 69.8361C47.7852 74.5686 51.4574 77.9974 56.5446 77.9974C58.992 77.9974 60.6561 77.2904 62.3201 75.5903V77.6337H66.1509V61.9364L62.3201 61.9324ZM57.1401 74.54C54.095 74.54 51.9917 72.6703 51.9917 69.9219C51.9917 67.0612 54.095 65.0178 57.0767 65.0178C60.0584 65.0178 62.1956 67.0305 62.1956 69.8913C62.1956 72.5007 60.312 74.54 57.1401 74.54Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_5"
          d="M84.8307 56.6896L78.5753 72.6116L72.3288 56.6875H67.8008L76.8433 77.6281H80.3593L89.3384 56.6875L84.8307 56.6896Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_6"
          d="M91.2661 55.8965V59.6645H95.4409V55.8965H91.2661ZM91.2344 61.9326V77.6299H95.4093V61.9326H91.2344Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_7"
          d="M112.145 56.6895V63.3202C110.92 62.0941 108.912 61.3647 106.712 61.3647C101.846 61.3647 98.0156 65.0427 98.0156 69.7527C98.0156 74.3994 101.815 77.9978 106.743 77.9978C109.098 77.9978 110.819 77.2908 112.489 75.5907V77.6341H116.32V56.6935L112.145 56.6895ZM107.404 74.5404C104.486 74.5404 102.224 72.3602 102.224 69.5832C102.224 66.9268 104.454 64.8221 107.312 64.8221C110.23 64.8221 112.46 66.9472 112.46 69.6956C112.46 72.4439 110.23 74.5404 107.404 74.5404Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_8"
          d="M133.272 61.9324V64.0288C131.827 62.3001 130.102 61.5625 127.589 61.5625C122.441 61.5625 118.734 65.0485 118.734 69.8361C118.734 74.5686 122.409 77.9974 127.494 77.9974C129.944 77.9974 131.608 77.2904 133.272 75.5903V77.6337H137.102V61.9364L133.272 61.9324ZM128.092 74.54C125.046 74.54 122.943 72.6703 122.943 69.9219C122.943 67.0612 125.046 65.0178 128.028 65.0178C131.01 65.0178 133.145 67.0305 133.145 69.8913C133.136 72.5007 131.261 74.54 128.092 74.54Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_9"
          d="M129.779 39.1249L124.866 39.8626C124.823 39.6296 124.775 39.3967 124.721 39.1678C122.645 30.2219 112.833 24.0079 102.898 25.4996C93.6384 26.8871 86.8644 34.5252 86.9301 42.8684C86.9354 43.7585 87.0195 44.6467 87.1814 45.5248L82.3568 46.2481L82.2594 46.2113C81.9455 44.4848 81.8695 42.7298 82.033 40.9864C82.9387 31.2722 91.1321 22.7165 102.079 21.0716C108.327 20.1337 114.678 21.5171 119.964 24.9541C124.017 27.572 127.082 31.2495 128.744 35.4897C129.205 36.6723 129.551 37.8886 129.779 39.1249Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_10"
          d="M100.753 -0.00489658L95.8398 0.732422L99.1989 18.9665L104.112 18.2292L100.753 -0.00489658Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_11"
          d="M89.4158 11.4779L85.0781 13.6875L90.5987 22.5157L94.9363 20.3061L89.4158 11.4779Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_12"
          d="M71.5552 13.0417L68.3164 16.457L83.8759 28.4765L87.1146 25.0612L71.5552 13.0417Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_13"
          d="M71.05 28.4159L69.3008 32.625L79.8171 36.1851L81.5663 31.976L71.05 28.4159Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_14"
          d="M134.03 19.0855L125.355 25.5254L128.52 28.9972L137.194 22.5573L134.03 19.0855Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_15"
          d="M128.112 4.64951L117.699 20.5664L121.988 22.8521L132.401 6.93518L128.112 4.64951Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_16"
          d="M110.64 8.347L108.582 18.3125L113.479 19.1364L115.537 9.17085L110.64 8.347Z"
          fill="#00B5B8"
        />
        <path
          id="Vector_17"
          d="M140 27.6939C139.442 29.0003 138.785 30.2708 138.035 31.4966C136.892 33.4019 135.586 35.224 134.13 36.9462C132.767 38.5633 131.266 40.0814 129.64 41.4867C128.509 42.463 127.312 43.3767 126.059 44.2227C119.737 48.4893 112.411 50.6696 104.281 50.7023C97.4889 50.7268 90.1444 49.2311 82.3585 46.2395L82.2611 46.2027C78.3847 44.6922 74.6241 42.9502 71.0044 40.9881C70.8301 40.8962 70.6512 40.798 70.4724 40.7C69.8588 40.3689 69.2362 40.0236 68.6295 39.6783C67.751 39.1817 66.8794 38.7035 66.0417 38.2581C58.6655 34.3409 51.6561 31.7704 45.2127 30.6179C32.7448 28.3886 22.2443 31.3413 14.0033 39.3922C7.75459 45.4978 5.22339 52.2879 5.19848 52.3574L0.253906 50.8842C0.369371 50.5674 3.17219 43.0478 10.1771 36.2045C16.7427 29.7863 28.33 22.8101 46.2248 26.006C53.2432 27.2626 60.8073 30.0212 68.6883 34.2081C69.5668 34.674 70.4837 35.1767 71.4052 35.6998C71.9847 36.0267 72.5779 36.3557 73.1688 36.6766L73.6714 36.9483C76.5392 38.4863 79.3315 39.8295 82.0483 40.9778C83.7086 41.6808 85.3402 42.3094 86.9431 42.8639C101.188 47.7986 113.26 47.0017 122.952 40.4588C123.556 40.0501 124.15 39.6197 124.734 39.1674C125.187 38.8201 125.624 38.4584 126.056 38.0865C127.008 37.2655 127.91 36.3985 128.757 35.4893C129.184 35.0371 129.599 34.5725 130.002 34.0957C131.293 32.5682 132.451 30.9525 133.464 29.2631C134.09 28.2394 134.642 27.18 135.117 26.0918L140 27.6939Z"
          fill="#FF8175"
        />
      </g>
      <defs>
        <clipPath id="clip0_1165_6487">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HolaVidaLogo;
